/* eslint-disable react-hooks/exhaustive-deps */

import { Grid } from "@material-ui/core";

import { RESET_STATE_FORM_FILTER } from "App/Component/layout/Wms/PerbekalanFarmasi/InventoryControl/DaftarInventoryControl/helpers";
import {
  DatatablesFooterServerSide,
  Loading,
  SearchInput,
} from "App/Component/ui";
import {
  DEFAULT_BOX_SHADOW,
  DISABLED_BUTTON_SUBMIT,
  STYLE_DEFAULT_MASTER,
  DEFAULT_SHOW_BUTTON_SUBMIT,
} from "App/constants";
import { useDatatablesServerSide } from "App/hooks";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import React, { useState, useEffect } from "react";
import { ModalForm, RESET_TAB_MODAL } from "./ModalForm";

import { getByFilterBarang } from "App/Component/layout/Wms/PerbekalanFarmasi/Master/MasterBarang/ui";
import { TableDaftarBarang } from "App/Component/layout/Wms/PerbekalanFarmasi/Master/MasterBarang/MasterBarang";
import { addItemById, deleteItemById } from "./helpers";
import { TableItemTransfer } from "pages/Penjualan/Master/Rikjang/tabs/TabBarang";
import { ITEM_TYPE_BARANG } from "pages/Penjualan/Master/Rikjang/constants";

function TabBarang({ formData, setFormData, templateID }) {
  const classes = STYLE_DEFAULT_MASTER();
  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useState(RESET_STATE_FORM_FILTER);
  const [formBarang, setFormBarang] = useState(RESET_TAB_MODAL);
  const [showModal, setShowModal] = useState(false);
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit,
    formSearch = formFilter
  ) => {
    setLoading(true);
    const res = await getByFilterBarang(
      {
        nama: formSearch.nama,
      },
      pages,
      limit
    );
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setTotalData(0);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  const handleChange = (text) => async (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });

    if (!isNull(e.target.value) && e.target.value.length > 2) {
      await setNewData(formFilter.pages, formFilter.limit, {
        nama: e.target.value,
      });
    } else {
      await setNewData(formFilter.pages, formFilter.limit, {
        nama: "",
      });
    }
  };

  const handleClickSelect = async (row) => {
    setFormBarang({
      id: "",
      item_type: ITEM_TYPE_BARANG,
      item_id: row.id,
      name: row.name,
      qty: 1,
    });
    setShowModal(!showModal);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      const barang = formData.barang;
      const checkBarang = barang.filter(
        (e) => e.item_id === formBarang.item_id
      );
      if (checkBarang.length === 0) {
        if (!isNull(templateID)) {
          const res = await addItemById({
            id_template: templateID,
            item_type: ITEM_TYPE_BARANG,
            item_id: formBarang.item_id,
            qty: formBarang.qty,
          });
          if (res.state) {
            barang.push({
              id: res.data.id,
              id_template: templateID,
              item_type: ITEM_TYPE_BARANG,
              item_id: formBarang.item_id,
              qty: formBarang.qty,
              nama_barang: formBarang.name,
            });
            setFormData({
              ...formData,
              barang,
            });
            defaultToastSuccess(res.message);
          } else {
            defaultToastError(res.message);
          }
          setShowModal(false);
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        } else {
          barang.push({
            item_type: ITEM_TYPE_BARANG,
            item_id: formBarang.item_id,
            qty: formBarang.qty,
            nama_barang: formBarang.name,
          });
          setFormData({
            ...formData,
            barang,
          });
          setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
          setShowModal(false);
        }
      } else {
        defaultToastError("Barang sudah ada");
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setShowModal(false);
      }
    } catch (error) {}
  };

  const clickDelete = async (row) => {
    const barang = formData.barang;
    const checkBarang = barang.filter((e) => e.item_id !== row.item_id);
    setFormData({
      ...formData,
      barang: checkBarang,
    });
    if (!isNull(templateID)) {
      const res = await deleteItemById(row.id);
      if (res.state) {
        defaultToastSuccess(res.message);
      } else {
        defaultToastError(res.message);
      }
    }
  };

  useEffect(() => {
    setNewData();
  }, []);

  return (
    <>
      <div>
        {showModal && (
          <ModalForm
            setShowModal={() => setShowModal(false)}
            form={formBarang}
            setForm={setFormBarang}
            disabled={disabled}
            handleSubmit={handleSubmit}
          />
        )}

        <Grid container spacing={2}>
          <Grid item sm={6}>
            <div
              style={{
                boxShadow: DEFAULT_BOX_SHADOW,
                padding: "1rem",
              }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}>
                <div>
                  <p className='fw-600 fs-14'>DAFTAR BARANG</p>
                </div>
                <div>
                  <SearchInput
                    withIcon={true}
                    onchange={handleChange("nama")}
                  />
                </div>
              </div>
              <Loading show={loading} />

              <TableDaftarBarang
                rows={rows}
                classes={classes}
                isSelect={true}
                handleClickSelect={handleClickSelect}
                handleClickUpdate={handleClickSelect}
              />
              <DatatablesFooterServerSide
                totalData={totalData}
                pagination={pagination}
                handleChangeLimit={handleChangeLimit}
                onPrevious={onPrevious}
                onNext={onNext}
                currentPage={pagination.page}
                handleClickPageNumber={handleClickPageNumber}
              />
            </div>
          </Grid>

          <Grid item sm={6}>
            <TableItemTransfer
              rows={formData.barang}
              clickDelete={clickDelete}
              filter='nama_barang'
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default TabBarang;
